import React from 'react';

import './history.styles.scss';

/* eslint-disable-next-line */
export interface HistoryProps {}

const history = [
  {
    date: {
      year: '2018',
      month: 'Month of May',
    },
    title: 'Founded',
    description: `Hop In is founded by friends; Erich Ko, Boyd Reid, and Erwin Komguem, in Erich’s parents’ basement.`,
    photoUrl: require('../../../assets/photos/history/founded.png'),
  },
  {
    date: {
      year: '2019',
      month: 'Month of June',
    },
    title: 'First Ride',
    description: `First Ride completed with Nutcracker Sweet Gift Baskets.`,
    photoUrl: require('../../../assets/photos/history/hopin-bus.png'),
  },
  {
    date: {
      year: '2020',
      month: 'Month of March',
    },
    title: 'COVID-19 Initiatives',
    customDescription: (
      <>
        <p>
          COVID Lockdown begins. Hop In shifts efforts to focus on assisting
          with community care initiatives.
        </p>
        <p>Over the course of 8 months, Hop In Covid Relief donated:</p>
        <ul>
          <li>
            120+ rides to work and free meals for frontline healthcare workers.
          </li>
          <li>25,000+ disposable masks to charities across Canada.</li>
        </ul>
      </>
    ),
    photoUrl: require('../../../assets/photos/history/covid.png'),
  },
  {
    date: {
      year: '2020',
      month: 'Month of October',
    },
    title: '10K Milestone',
    description: `First 10,000km serviced in helping employees get to work safely.`,
    photoUrl: require('../../../assets/photos/history/milestone.png'),
  },
];

export function History(props: HistoryProps) {
  return (
    <div className="history ptb-100 bg-color">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Our Story</span>
          <h2>History Begins in 2018</h2>
        </div>

        <ol className="timeline history-timeline">
          {history.map(
            ({ title, description, customDescription, date, photoUrl }) => (
              <li className="timeline-block">
                <div className="timeline-date">
                  <span>{date.year}</span>
                  {date.month}
                </div>

                <div className="timeline-icon">
                  <span className="dot-badge"></span>
                </div>

                <div className="timeline-content">
                  <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12">
                      <div className="content">
                        <h3>{title}</h3>
                        {description && <p>{description}</p>}
                        {customDescription || null}
                      </div>
                    </div>

                    <div className="col-lg-5 col-md-12">
                      <div className="image">
                        <img src={photoUrl} alt="history entry" />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            )
          )}
        </ol>
      </div>
    </div>
  );
}

export default History;
